import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink } from "react-router-dom";

import { Page, Card, Button, Alert } from "tabler-react";
import { SiteWrapper } from "../common";

import ReactTable from "react-table";

import { findWorkRequests } from '../actions';
import * as moment from 'moment';
import { RequisitionSettings } from './';
import Auth from '../auth/auth';

const auth = new Auth({});

const dataStoreKey = 'workRequestDataStore';

class RequisitionPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      workRequests: [],
      type: this.determinePageType(),
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
      page: 1,
      pageSize: 50,
      order: '',
      ascDesc: '',
      name: '',
      referenceNum: '',
      status: '',
      progress: ''
    };

    this.fetchWorkRequests = this.fetchWorkRequests.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onPageSizeChange = this.onPageSizeChange.bind(this);
    this.onSortedChange = this.onSortedChange.bind(this);
    this.onFilteredChange = this.onFilteredChange.bind(this);
    this.initDataStore = this.initDataStore.bind(this);

  }

  componentDidMount() {

    localStorage.setItem(RequisitionSettings.pagePathKey, this.props.location.pathname);

    let alert = localStorage.getItem(RequisitionSettings.alertKey);
    if (alert) {
      alert = JSON.parse(alert);
      this.setState({ alert });
      localStorage.removeItem(RequisitionSettings.alertKey);
    }

    this.initDataStore();
  }

  determinePageType() {
    return window.location.href.toString().indexOf('mine') > -1 ? 'My_Requests'
    : window.location.href.toString().indexOf('pending') > -1 ? 'Pending_Approver'
    : 'Assigned_To_Me';
  }

  fetchWorkRequests(state, instance) {
    this.setState({ loading: true });

    let { type, page, pageSize, order, ascDesc, name, referenceNum, status, progress } = this.state;

    this.props.findWorkRequests(page, pageSize, order, ascDesc, null, (name ? name.value : null), (referenceNum ? referenceNum.value : ''), (status ? status.value : null), (progress ? progress.value : null), type,
    (response) => {
        console.log('findWorkRequests', response);
        this.setState({ loading: false, workRequests: response.data });
        this.storeInDataStore();
    }, (error) => {
      console.log('findWorkRequests', error);
      this.setState({ loading: false, workRequests: [] });
    });
  }

  initDataStore() {
    const jsonDataStore = localStorage.getItem(dataStoreKey);

    if (!jsonDataStore) {
      this.fetchWorkRequests();
      return;
    }

    let dataStore = JSON.parse(jsonDataStore);
    const { page, pageSize, order, ascDesc, name, referenceNum, status, progress, expiresOn } = dataStore;

    if (moment().isAfter(moment(expiresOn), 'second')) {
        console.log('fetchWorkRequests_expires', expiresOn, moment().toDate());
        this.fetchWorkRequests();
        return
    }

    this.setState({ page, pageSize, order, ascDesc, name, referenceNum, status, progress }, (prevState, props) => {
        this.fetchWorkRequests();
    });
  }

  onPageChange(pageIndex) {
    console.log('onPageIndex', pageIndex);
    this.setState({ page: pageIndex + 1 }, (prevState, props) => {
      this.fetchWorkRequests();
    });
  }

  onPageSizeChange(pageSize, pageIndex) {
    console.log('onPageSizeChange', pageSize, pageIndex);
    this.setState({ page: pageIndex + 1, pageSize }, (prevState, props) => {
      this.fetchWorkRequests();
    });
  }

  onSortedChange(newSorted, column, shiftKey) {
    console.log('onSortedChange', newSorted, column, shiftKey);
    const lastIndex = newSorted.length - 1;
    let order = newSorted[lastIndex].id;
    let ascDesc = newSorted[lastIndex].desc ? 'desc' : 'asc';
    this.setState({ order, ascDesc }, (prevState, props) => {
      this.fetchWorkRequests();
    });
  }

  onFilteredChange(filtered, column) {
    console.log('onFilteredChange', filtered, column);
    const status = filtered.find(f => f.id === 'status');
    const progress = filtered.find(f => f.id === 'progress');
    const name = filtered.find(f => f.id === 'name');
    const referenceNum = filtered.find(f => f.id === 'referenceNum');
    this.setState({ status, progress, name, referenceNum }, (prevState, props) => {
      this.fetchWorkRequests();
    });
  }

  storeInDataStore() {
    let { page, pageSize, order, ascDesc, name, referenceNum, status, progress } = this.state;
    if (localStorage.getItem(dataStoreKey)) localStorage.removeItem(dataStoreKey);
    let dataStore = {
      page, pageSize, order, ascDesc, name, referenceNum, status, progress,
      expiresOn: moment().add(30, 'm').toDate()
    };
    localStorage.setItem(dataStoreKey, JSON.stringify(dataStore));
   }

  checkValidWorkItem(item) {
    return auth.hasAccess('request', 'admin') || (item.workRequest && item.workRequest.createdBy && item.workRequest.createdBy.toLowerCase() === auth.name.toLowerCase()) || item.createdBy.toLowerCase() === auth.name.toLowerCase() || item.assignedTo.find(a => a.toLowerCase() === auth.name.toLowerCase());
  }

  columns() {
    return [
        {
          Header: 'Row',
          accessor: 'id',
          filterable: false,
          sortable: false,
          maxWidth: 40,
          Cell: row => (
            <span>{row.index + 1}</span>
          )
        },
        {
          Header: 'PRF Num or ID Num',
          accessor: 'referenceNum',
          Cell: row => (
            <NavLink to={`/requisition/${row.value}`} className="visited">
                {row.value}
            </NavLink>
          )
        },
        {
          Header: 'Title',
          accessor: 'name',
          minWidth: 250
        },

        {
          Header: 'Submitted By',
          filterable: false,
          accessor: 'submittedBy'
        },
        {
          Header: 'Submitted Date',
          filterable: false,
          accessor: 'submittedOn',
          Cell: row => (
            <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
          )
        },
        {
          Header: 'Verified By',
          filterable: false,
          accessor: 'verifiedBy'
        },
        {
          Header: 'Verified Date',
          filterable: false,
          accessor: 'verifiedOn',
          Cell: row => (
            <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
          )
        },
        {
          Header: 'Items',
          filterable: false,
          sortable: false,
          id: 'workItems',
          accessor: d => d.workItems.filter(item => this.checkValidWorkItem(item)).length
        },
        {
          Header: 'Status',
          accessor: 'status',
          id: 'status',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
        },
        {
          Header: 'Progress',
          accessor: 'progress',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="In_Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Canceled">Canceled</option>
                {/* <option value="Expired">Expired</option> */}
              </select>
         }
      ];
  }

  subColumns() {
    return [
        {
          Header: 'Reference',
          accessor: 'referenceNum',
          Cell: row => (
            <NavLink to={`/requisition/item/${row.value}`} className="visited">{row.value}</NavLink>
          )
        },
        {
          Header: 'Name',
          accessor: 'name'
        },
        {
          Header: 'Code',
          accessor: 'code'
        },
        {
          Header: 'Work Order/By KL No.',
          accessor: 'workOrderNum'
        },
        {
          Header: 'Quantity',
          accessor: 'requestQuantity'
        },
        {
          Header: 'Assigned To',
          accessor: 'assignedTo',
          Cell: row => (
              <span>{row.value.join(', ')}</span>
          )
        },
        {
          Header: 'Checked',
          id: 'isChecked',
          accessor: 'isChecked',
          Cell: row => this.renderFlags(row.value)
        },
        {
          Header: 'Locked',
          id: 'isLocked',
          accessor: 'isLocked',
          Cell: row => this.renderFlags(row.value)
        },
        {
          Header: 'Connected',
          id: 'connected',
          accessor: d => d.references.length > 0 ? d.references[0].referenceNum : '',
        },
        {
          Header: 'Last Modified',
          id: 'modifiedOn',
          accessor: d => d.modifiedOn,
          Cell: row => (
            <span>{row.value ? moment(row.value).format('DD/MM/YY hh:mm a') : ''}</span>
          )
        },
        {
          Header: 'Status',
          accessor: 'status',
          Cell: row => this.renderStatus(row.value)
        },
        {
          Header: 'Progress',
          accessor: 'progress',
          Cell: row => this.renderStatus(row.value)
        }
      ];
  }

  renderStatus(value) {
    return (
      <span>
       <span className={`d-inline-block rounded-circle mr-2 ${
         value === 'Approved' || value === 'Completed' ? 'bg-success'
          : value === 'Rejected' || value === 'Rejected' ? 'bg-danger'
          : value === 'Canceled' ? 'bg-warning'
          : value === 'In_Progress' ? 'bg-primary'
          : 'bg-secondary'
       }`} style={{
         width: '8px', height: '8px'
       }}>
       </span>
       {value.replace('_', ' ')}
     </span>
    );
  }

  renderFlags(value) {
    return (
      <span>
        {console.log('flags', value)}
       <span className={`d-inline-block rounded-circle mr-2 ${
         value ? 'bg-success' : 'bg-danger'
       }`} style={{
         width: '8px', height: '8px'
       }}>
       </span>
       {value ? 'Yes' : 'No'}
     </span>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  render ()  {
    const { loading, type, workRequests, page, pageSize, order, ascDesc, name, referenceNum, status, progress } = this.state;
    const { pagination } = workRequests;
    const { totalPages } = pagination ? pagination : { totalPages: 1 };

    let filtered = [];
    let sorted = [];

    if (order && ascDesc) sorted.push({ id: order, desc: ascDesc === 'desc' });
    if (name) filtered.push(name);
    if (referenceNum) filtered.push(referenceNum);
    if (status) filtered.push(status);
    if (progress) filtered.push(progress);

    console.log("redner", filtered);

    return (
        <SiteWrapper>
            <Page.Content>
              {this.renderAlert()}
              <Card>
                <Card.Header>
                  <Card.Title>
                    {type.replace(new RegExp('_', 'g'), ' ')}
                  </Card.Title>
                  <Card.Options>
                    {auth.hasAccess('request', 'create') && type === 'My_Requests' &&
                      <NavLink to="/requisition/new">
                        <Button color="success" icon="plus">New Request</Button>
                      </NavLink>
                    }
                  </Card.Options>
                </Card.Header>
                <Card.Body>
                  <ReactTable
                    data={workRequests.items}
                    columns={this.columns()}
                    loading={loading}
                    page={page ? page - 1 : 0}
                    pages={totalPages}
                    pageSize={pageSize ? pageSize : 50}
                    filtered={filtered}
                    sorted={sorted}
                    showPaginationTop
                    showPaginationBottom
                    filterable
                    manual
                    className="-striped -highlight"
                    // onFetchData={this.fetchWorkRequests}
                    onPageChange={this.onPageChange} // Called when the page index is changed by the user
                    onPageSizeChange={this.onPageSizeChange} // Called when the pageSize is changed by the user. The resolve page is also sent to maintain approximate position in the data
                    onSortedChange={this.onSortedChange} // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, `column` will be an array of columns
                    onFilteredChange={this.onFilteredChange} // Called when a user enters a value into a filter input field or the value passed to the onFiltersChange handler by the Filter option.
                    SubComponent={row => {
                      const workItems = row.original.workItems.filter(item => this.checkValidWorkItem(item));
                      return (
                         <ReactTable
                           data={workItems}
                           columns={this.subColumns()}
                           defaultPageSize={workItems.length}
                           showPagination={false}
                           className="table-secondary table-sm table-striped"
                         />
                      )
                    }}
                  />
                </Card.Body>
              </Card>
            </Page.Content>
        </SiteWrapper>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({  findWorkRequests }, dispatch)
}

function mapStateToProps({ workRequests }) {
  return { workRequests };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequisitionPage)



// WEBPACK FOOTER //
// ./src/requisition/requisition.react.js